var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        ref: "table-stock-counting-compliance",
        staticClass: "mb-1 bordered",
        attrs: {
          responsive: "",
          "show-empty": "",
          striped: "",
          "empty-text": _vm.getEmptyTableMessage(
            _vm.$t("regra de contagem por loja"),
            "female",
            _vm.queryExecuted
          ),
          fields: _vm.fields,
          items: _vm.items,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(compliancePercent)",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  "b-badge",
                  { attrs: { variant: _vm.complianceVariant(item) } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("percentage")(item.compliancePercent, 0)
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "cell(missedDays)",
            fn: function (ref) {
              var item = ref.item
              return [
                item.missedDays > 0
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        staticClass:
                          "text-danger font-weight-bold cursor-pointer",
                        attrs: { title: _vm.missedDatesTooltip(item) },
                      },
                      [_vm._v(" " + _vm._s(item.missedDays) + " ")]
                    )
                  : _c("span", [_vm._v("0")]),
              ]
            },
          },
          {
            key: "cell(daysOfWeek)",
            fn: function (ref) {
              var item = ref.item
              return [_vm._v(" " + _vm._s(_vm.dayNames(item.daysOfWeek)) + " ")]
            },
          },
          {
            key: "cell(countings)",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(item.performedCountings) +
                    " / " +
                    _vm._s(item.requiredCountings) +
                    " "
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("e-pagination-summary", {
                attrs: {
                  "current-page": _vm.paging.currentPage,
                  "per-page": _vm.paging.pageSize,
                  total: _vm.paging.rowCount,
                  "total-on-page": _vm.paging.rowsInCurrentPage,
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("b-pagination", {
                attrs: {
                  value: _vm.paging.currentPage,
                  align: "right",
                  "total-rows": _vm.paging.rowCount,
                  "per-page": _vm.paging.pageSize,
                  "aria-controls": "table-stock-counting-compliance",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("page-change", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }